<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="push__bottom">
        <div class="grid-col grid-col--soft grid-xsmall-12 grid-large-9 push__top">
            <BackLink/>
        </div>
        <Form :data="form"
          :error="$v.form.$error"
          :formId="id"
          :formErrorMessage="errorMessage"
          @submit="submitSection"
          :submitButtonText="buttonText">   
            <span class="caption-xl">{{subtitle}}</span>
            <Fieldset
                :title="title"
                type="heading">
                <Textarea
                    id="furtherinfo"
                    name="furtherinfo"
                    :label="question"
                    errorMessage="This is a required field"
                    v-model="form.information"
                    :validate="$v.form.information"
                />      
            </Fieldset>            
        </Form>        
      </article>
    </div>
  </div>
</template>

<script>

import { dataService } from "../shared";

export default {
  name: "SectionOfQuestionsImpact",
  created() {
    this.loadQuestion();
    this.loadAnswer();
  },
  data() {
    return {
      id : "",
      title: "",
      content: "",
      destination: "",
      errorMessage: "Please provide further information that would be considered important",
      form : {
        information: null,
      }
    };
  },
  validations() {
    return {
        form : {
            information: {}
        }
    }
},

  methods: {    
    loadQuestion() {
      let json = dataService.getQuestions();
      let questions = json.questions;
      let currentQuestion = dataService.findElement(
        questions,
        dataService.parseUrl()
      );
      this.id = currentQuestion.id;
      this.title = currentQuestion.title;
      this.subtitle = currentQuestion.subtitle;
      this.buttonText = currentQuestion.buttonText;
      this.destination = currentQuestion.destination;
      this.question = currentQuestion.question;
    },
    loadAnswer() {
      let previousResponse = dataService.wasAnsweredBefore(this.id);
      this.form.information = previousResponse.furtherInfo;
    },
    startQuestionnaire() {        
      this.$router.push({ path: this.destination });
    },
    logResponse() {
      let response = {
        id: this.id,
        questionType: "SectionOfQuestionsFurtherInfo",
        furtherInfo: this.form.information
      };
      dataService.logResponse(response);
    },
    submitForm(form, valid) {
        valid.$touch();
        if (valid.$pending || valid.$error) {
            setTimeout(() => {
                document.querySelector(".error-summary__link").focus()
            }, 0);
            return;	
        }
        this.logResponse();
        this.$router.push({ name: this.destination.toLowerCase() });
    },
    submitSection() {
      this.submitForm(this.form, this.$v.form);
    },
    redirectToTimeout() {
      dataService.resetResponses();
      this.$router.push({ name: "timeout" });
    }
  }
};
</script>